import { combineReducers } from 'redux';
import roomDetailReducer from './roomDetail';
import groupListReducer from './groupList';
import accountReducer from './account';
import notificationListReducer from './notification';
import noteListReducer from './noteList';
import settingReducer from './setting';

const rootReducer = combineReducers({
  roomDetailReducer,
  groupListReducer,
  accountReducer,
  notificationListReducer,
  noteListReducer,
  settingReducer,
});

export default rootReducer;
